import { closeDetail, useAppStore } from '../store/appStore';
import type { SearchPin } from '../types/search';
import { Button } from './ui';

/** SearchPinDetailView: title, subtitle, Remove Pin and Done (220 pt sheet on iOS). */
export function SearchPinDetail({ pin }: { pin: SearchPin }) {
  const removeSearchPin = useAppStore((s) => s.removeSearchPin);
  return (
    <div className="pin-detail">
      <div className="pin-detail-row">
        <svg width="28" height="28" viewBox="0 0 24 24" aria-hidden="true" className="pin-detail-icon">
          <path d="M12 22s7-7.1 7-12A7 7 0 0 0 5 10c0 4.9 7 12 7 12z" fill="currentColor" />
          <circle cx="12" cy="10" r="2.8" fill="#fafafa" />
        </svg>
        <div>
          <h2 className="pin-detail-title">{pin.title}</h2>
          {pin.subtitle ? <p className="pin-detail-subtitle">{pin.subtitle}</p> : null}
        </div>
      </div>
      <div className="pin-detail-actions">
        <Button
          variant="danger"
          onClick={() => {
            removeSearchPin(pin.id);
            closeDetail();
          }}
        >
          Remove Pin
        </Button>
        <Button variant="primary" onClick={closeDetail}>
          Done
        </Button>
      </div>
    </div>
  );
}
